// extracted by mini-css-extract-plugin
module.exports = {"helpModalWrap":"_1mDg4","cardWrap":"_1MAX2","icon":"_3mFp4","heading":"_3Mzsn","headingWraper":"_1QeK2"};